import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
import { HTMLElementType } from '@cloud-sn/v-utils';
import debounce from 'lodash/debounce';
import InkTabBar from './inkTabBar.js';
import { addEventListener, getElementOffset, getElementWH, isTransform3dSupported, isVertical } from './utils';
var __vue_script__ = {
  name: 'ScrollInkTabBar',
  components: {
    InkTabBar: InkTabBar
  },
  props: {
    prefixCls: String,
    tabs: Array,
    tabBarPosition: String,
    rootNode: HTMLElementType(),
    scrollAnimated: {
      type: Boolean,
      default: true
    },
    size: String
  },
  data: function data() {
    return {
      init: true,
      activeTab: null,
      offset: 0,
      isSupportedTransform3d: isTransform3dSupported(),
      // isSupportedTransform3d: false,
      minOffset: 0,
      navWrapWH: 0,
      oldHasArrow: this.hasArrow,
      resizeEvent: null,
      debounceCalcMinOffset: null
    };
  },
  computed: {
    navPrefixCls: function navPrefixCls() {
      var prefixCls = this.prefixCls;
      return "".concat(prefixCls, "-nav");
    },
    classes: function classes() {
      var _ref;

      var navPrefixCls = this.navPrefixCls,
          hasArrow = this.hasArrow;
      return _ref = {}, _defineProperty(_ref, "".concat(navPrefixCls, "-container"), true), _defineProperty(_ref, "".concat(navPrefixCls, "-container-scrolling"), hasArrow), _ref;
    },
    navClasses: function navClasses() {
      var _ref2;

      var navPrefixCls = this.navPrefixCls,
          scrollAnimated = this.scrollAnimated;
      return _ref2 = {}, _defineProperty(_ref2, navPrefixCls, true), _defineProperty(_ref2, "".concat(navPrefixCls, "-animated"), scrollAnimated), _defineProperty(_ref2, "".concat(navPrefixCls, "-no-animated"), !scrollAnimated), _ref2;
    },
    navStyle: function navStyle() {
      return this.buildNavStyle();
    },
    isCanNext: function isCanNext() {
      var minOffset = this.minOffset,
          offset = this.offset;

      if (minOffset > 0) {
        return false;
      }

      if (offset > minOffset) {
        return true;
      }

      return false;
    },
    isCanPrev: function isCanPrev() {
      var minOffset = this.minOffset,
          offset = this.offset;

      if (minOffset > 0) {
        return false;
      }

      if (offset < 0) {
        return true;
      }

      return false;
    },
    hasArrow: function hasArrow() {
      return this.isCanNext || this.isCanPrev;
    },
    prevClasses: function prevClasses() {
      var _ref3;

      var prefixCls = this.prefixCls,
          isCanPrev = this.isCanPrev,
          hasArrow = this.hasArrow;
      return _ref3 = {}, _defineProperty(_ref3, "".concat(prefixCls, "-tab-prev"), 1), _defineProperty(_ref3, "".concat(prefixCls, "-tab-btn-disabled"), !isCanPrev), _defineProperty(_ref3, "".concat(prefixCls, "-tab-arrow-show"), hasArrow), _ref3;
    },
    nextClasses: function nextClasses() {
      var _ref4;

      var prefixCls = this.prefixCls,
          isCanNext = this.isCanNext,
          hasArrow = this.hasArrow;
      return _ref4 = {}, _defineProperty(_ref4, "".concat(prefixCls, "-tab-next"), 1), _defineProperty(_ref4, "".concat(prefixCls, "-tab-btn-disabled"), !isCanNext), _defineProperty(_ref4, "".concat(prefixCls, "-tab-arrow-show"), hasArrow), _ref4;
    }
  },
  watch: {
    activeTab: function activeTab(nVal, oVal) {
      if (nVal && nVal !== oVal) {
        this.scrollToActiveTab();
      }
    },
    tabBarPosition: function tabBarPosition(nVal, oVal) {
      if (nVal && nVal !== oVal) {
        this.offset = 0;
        this.minOffset = 0;
        this.navWrapWH = 0;
      }
    }
  },
  created: function created() {
    this.oldHasArrow = this.hasArrow;
    this.debounceCalcMinOffset = debounce(this.calcMinOffset, 200);
  },
  mounted: function mounted() {
    var _this = this;

    this.resizeEvent = addEventListener(window, 'resize', debounce(function () {
      _this.$nextTick(function () {
        _this.calcMinOffset(); // 当前hasArrow与上一次的hasArrow不一致时, 会触发next button的onTransitionend事件,由它进行重新计算
        // if (this.hasArrow === this.oldHasArrow) {


        _this.scrollToActiveTab(); // }

      });
    }, 150));
  },
  updated: function updated() {
    var $refs = this.$refs;
    var tabs = $refs.tabs;

    if (tabs) {
      var _ref5 = tabs.filter(function (v) {
        return !!v.getAttribute('data-active');
      }) || [],
          _ref6 = _slicedToArray(_ref5, 1),
          activeTab = _ref6[0];

      this.activeTab = activeTab;
    } // TODO:需优化, 有点难度


    this.debounceCalcMinOffset();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.resizeEvent) {
      this.resizeEvent.remove();
    }
  },
  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var activeTab = this.activeTab,
          $refs = this.$refs,
          calcOffset = this.calcOffset,
          tabBarPosition = this.tabBarPosition;
      var offset = this.offset;
      var navWrapRef = $refs.navWrapRef;

      if (activeTab && navWrapRef) {
        offset += calcOffset(navWrapRef, activeTab, tabBarPosition);
        this.setOffset(offset);
      }
    },
    calcMinOffset: function calcMinOffset() {
      var $refs = this.$refs,
          tabBarPosition = this.tabBarPosition;
      var navRef = $refs.navRef,
          navWrapRef = $refs.navWrapRef;
      var navWH = getElementWH(navRef, tabBarPosition);
      var navWrapWH = getElementWH(navWrapRef, tabBarPosition);
      this.minOffset = navWrapWH - navWH;
      this.navWrapWH = navWrapWH;
    },
    calcOffset: function calcOffset(navWrapRef, activeTab, tabBarPosition) {
      var offset = 0;
      var activeOffset = getElementOffset(activeTab, tabBarPosition);
      var navWrapOffset = getElementOffset(navWrapRef, tabBarPosition);

      if (activeOffset.v1 < navWrapOffset.v1) {
        offset = navWrapOffset.v1 - activeOffset.v1;
      } else if (activeOffset.v2 > navWrapOffset.v2) {
        offset = navWrapOffset.v2 - activeOffset.v2;
      }

      return offset;
    },
    setOffset: function setOffset(offset) {
      this.offset = offset;
    },
    buildNavStyle: function buildNavStyle() {
      var minOffset = this.minOffset,
          isSupportedTransform3d = this.isSupportedTransform3d,
          tabBarPosition = this.tabBarPosition;
      var style = {};
      var offset = this.offset;
      offset = Math.min(0, Math.max(offset, minOffset));

      if (!isVertical(tabBarPosition)) {
        if (isSupportedTransform3d) {
          style = {
            transform: "translate3d(".concat(offset, "px, 0,0)")
          };
        } else {
          style = {
            left: "".concat(offset, "px")
          };
        }
      } else if (isSupportedTransform3d) {
        style = {
          transform: "translate3d(0, ".concat(offset, "px,0)")
        };
      } else {
        style = {
          top: "".concat(offset, "px")
        };
      }

      if (offset !== this.offset) {
        this.setOffset(offset);
      }

      return style;
    },
    itemClasses: function itemClasses(tab) {
      var _ref7;

      var prefixCls = this.prefixCls;
      var isActive = tab.isActive,
          disabled = tab.disabled;
      return _ref7 = {}, _defineProperty(_ref7, "".concat(prefixCls, "-tab"), true), _defineProperty(_ref7, "".concat(prefixCls, "-tab-disabled"), disabled), _defineProperty(_ref7, "".concat(prefixCls, "-tab-active"), isActive), _ref7;
    },
    onTabClick: function onTabClick(tab, e) {
      this.$emit('tab-click', tab.vm, tab.name, e);
    },
    onPrev: function onPrev(e) {
      var navWrapWH = this.navWrapWH;
      this.setOffset(this.offset + navWrapWH);
      this.$emit('prev-click', e);
    },
    onNext: function onNext(e) {
      var navWrapWH = this.navWrapWH;
      this.setOffset(this.offset - navWrapWH);
      this.$emit('next-click', e);
    },
    onTransitionEnd: function onTransitionEnd(e) {
      e.stopPropagation(); // button css中需要含有opacity transition过渡效果,不然不会有效
      // fixed 由于滚动按钮存在transition过渡,而无法获取到正确navWrapRef宽度的问题

      if (e.propertyName === 'opacity') {
        var calcMinOffset = this.calcMinOffset,
            scrollToActiveTab = this.scrollToActiveTab; // if (oldHasArrow !== hasArrow) {

        setTimeout(function () {
          calcMinOffset();
          scrollToActiveTab();
        }, 0); // this.oldHasArrow = hasArrow;
        // }
      }
    }
  },
  render: function render() {
    var _this2 = this;

    var h = arguments[0];
    var tabs = this.tabs,
        prefixCls = this.prefixCls,
        rootNode = this.rootNode,
        tabBarPosition = this.tabBarPosition,
        activeTab = this.activeTab,
        $refs = this.$refs,
        itemClasses = this.itemClasses,
        onTabClick = this.onTabClick,
        navPrefixCls = this.navPrefixCls,
        classes = this.classes,
        navClasses = this.navClasses,
        navStyle = this.navStyle,
        onPrev = this.onPrev,
        onNext = this.onNext,
        isCanPrev = this.isCanPrev,
        isCanNext = this.isCanNext,
        prevClasses = this.prevClasses,
        nextClasses = this.nextClasses,
        size = this.size;
    var wrapNode = $refs.navRef || rootNode;
    var prevBtn = h("span", {
      "on": {
        "click": function click(e) {
          return isCanPrev ? onPrev(e) : null;
        }
      },
      "attrs": {
        "unselectable": true
      },
      "class": prevClasses
    }, [h("span", {
      "class": "".concat(prefixCls, "-tab-prev-icon")
    })]);
    var nextBtn = h("span", {
      "ref": "nextBtnRef",
      "on": {
        "transitionend": this.onTransitionEnd,
        "click": function click(e) {
          return isCanNext ? onNext(e) : null;
        }
      },
      "attrs": {
        "unselectable": true
      },
      "class": nextClasses
    }, [h("span", {
      "class": "".concat(prefixCls, "-tab-next-icon")
    })]);
    var ink = h("ink-tab-bar", {
      "attrs": {
        "prefixCls": prefixCls,
        "activeTab": activeTab,
        "wrapNode": wrapNode,
        "tabBarPosition": tabBarPosition,
        "size": size
      }
    });
    var items = tabs.map(function (item, i) {
      var event = {};

      if (!item.disabled && !item.isActive) {
        event.on = {
          click: onTabClick.bind(_this2, item)
        };
      }

      return h("div", _mergeJSXProps([{
        "ref": "tabs",
        "refInFor": true,
        "key": i,
        "attrs": {
          "role": "tab",
          "data-active": item.isActive
        },
        "class": itemClasses(item)
      }, event]), [item.tab]);
    });
    return h("div", {
      "attrs": {
        "role": "navContainer"
      },
      "class": classes
    }, [prevBtn, nextBtn, h("div", {
      "ref": "navWrapRef",
      "attrs": {
        "role": "navWrap"
      },
      "class": "".concat(navPrefixCls, "-wrap")
    }, [h("div", {
      "class": "".concat(navPrefixCls, "-scroll")
    }, [h("div", {
      "ref": "navRef",
      "attrs": {
        "role": "nav"
      },
      "class": navClasses,
      "style": navStyle
    }, [[ink, items]])])])]);
  }
};
/* template */

/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = undefined;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "scrollableInkTabBar.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);